<template>
  <Teleport :to="window.size.mobile ? '#mobile-tp-login' : '#desktop-tp-login'">
    <button v-if="window.size.mobile"
            @click="openModal"
            class="text-zt-red border border-zt-red w-full rounded-[5px] whitespace-nowrap text-[14px] 
            font-medium py-3 px-4 tracking-[0.001em] leading-5 xl:bg-zt-red xl:text-white"
            data-bs-dismiss="offcanvas"
            data-bs-target="#mobile-menu">
      LOGOWANIE
    </button>
    <button v-else
            @click="openModal"
            class="whitespace-nowrap border-zt-main border rounded-lg py-3 px-3 transition-colors
                   w-full font-semibold text-left zt-hover
                   hover:bg-zt-main xl:px-8 xl:py-2 xl:text-center xl:font-normal xl:w-fit">
      Zaloguj się
    </button>
  </Teleport>
  <div v-if="isLoginModalOpen"
       class="bg-black/50 backdrop-blur-sm w-full h-full fixed z-modal top-0 left-0"></div>
  <Transition>
    <div v-click-outside="outsideClickOptions" v-if="isLoginModalOpen"
         class="login-modal bg-zt-normal rounded-zt h-full w-full fixed top-0 left-1/2
                -translate-x-1/2 z-modal xl:h-[755px] xl:w-[356px] xl:top-1/2 xl:-translate-y-1/2">
      <div class="x-close-modal" @click.stop="closeModal"></div>
      <div class="w-full h-full pt-[53px]">
        <div class="bg-zt-normal max-h-full rounded-zt overflow-y-auto h-[inherit]">
          <div class="px-12 py-1 border-b border-t border-zt-main min-h-[40px] flex justify-between items-center
                      relative">
            <button @click="currentCard = 'login'" class="text-xs font-semibold tracking-wide transition-all zt-hover py-2 px-2"
                    :class="{'text-zt-red': currentCard==='login'}">ZALOGUJ SIĘ</button>
            <button @click="currentCard = 'register'" class="text-xs font-semibold tracking-wide transition-all zt-hover py-2 px-2"
                    :class="{'text-zt-red': currentCard==='register'}">ZAREJESTRUJ SIĘ</button>
            <div class="block absolute bottom-0 w-20 h-0.5 transition-[left] bg-zt-red"
                 :style="'left:'+(currentCard==='login' ? '56px' : 'calc(100% - 150px)')+';'"></div>
          </div>
          <div class="px-11 pt-8 pb-4 flex flex-col gap-y-5">
            <template v-if="currentCard !== 'success_register'">
              <a :href="'/wp-login.php?loginSocial=google&amp;redirect='+window.location.href"
                 class="no-default-style bg-white rounded-lg py-2 flex items-center justify-center w-full" rel="nofollow"
                 aria-label="Zaloguj się" data-plugin="nsl" data-action="connect" data-provider="google"
                 data-popupwidth="600" data-popupheight="600">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M11.1929 4.88479C12.7009 4.88479 14.0855 5.42556 15.1908 6.32489L18.5831 2.93487C16.6108 1.11369 14.0289 0 11.1929 0C6.89535 0 3.16851 2.54001 1.29297 6.26216L5.06524 9.38152C5.97904 6.75994 8.37377 4.88479 11.1929 4.88479Z" fill="#F44336"/>
                  <path d="M22.2889 13.1907C22.3472 12.7104 22.3858 12.2205 22.3858 11.7235C22.3858 10.8854 22.2984 10.0694 22.1389 9.28113H11.1934V14.1659H17.2431C16.7537 15.4983 15.8823 16.6257 14.7731 17.4089L18.5594 20.5399C20.5665 18.6945 21.94 16.1104 22.2889 13.1907Z" fill="#2196F3"/>
                  <path d="M4.66353 11.7235C4.66353 10.8995 4.80983 10.1132 5.06481 9.38157L1.29255 6.26221C0.470395 7.89389 0 9.75025 0 11.7235C0 13.6748 0.461742 15.5106 1.26682 17.129L5.04386 14.0057C4.80198 13.291 4.66353 12.5251 4.66353 11.7235Z" fill="#FFC107"/>
                  <path d="M11.1932 18.5622C8.35265 18.5622 5.94249 16.6586 5.04463 14.0056L1.26758 17.129C3.13396 20.881 6.87463 23.447 11.1932 23.447C14.0173 23.447 16.5924 22.3481 18.5592 20.5399L14.773 17.4089C13.75 18.1313 12.5255 18.5622 11.1932 18.5622Z" fill="#00B060"/>
                  <path opacity="0.1" d="M11.1918 23.2027C7.89779 23.2027 4.93589 21.7791 2.8418 19.5111C4.89171 21.9208 7.86807 23.447 11.1918 23.447C14.4848 23.447 17.4365 21.9509 19.4818 19.579C17.3939 21.8102 14.4545 23.2027 11.1918 23.2027Z" fill="black"/>
                  <path opacity="0.1" d="M11.1934 13.9216V14.1659H17.2431L17.3376 13.9216H11.1934Z" fill="black"/>
                  <path d="M22.379 11.8664C22.3797 11.8185 22.3841 11.7714 22.3841 11.7233C22.3841 11.7097 22.3821 11.6966 22.382 11.683C22.3814 11.7443 22.3785 11.8049 22.379 11.8664Z" fill="#E6E6E6"/>
                  <path opacity="0.2" d="M11.1934 9.28113V9.52537H22.1858C22.1711 9.44475 22.1551 9.36115 22.1389 9.28113H11.1934Z" fill="white"/>
                  <path d="M22.138 9.2811H11.1925V14.1659H17.2422C16.3014 16.7271 13.9693 18.5622 11.1925 18.5622C7.58666 18.5622 4.66353 15.5004 4.66353 11.7235C4.66353 7.94655 7.58666 4.88479 11.1925 4.88479C12.5 4.88479 13.7051 5.30553 14.726 5.99919C14.8823 6.10557 15.0435 6.20545 15.1903 6.32489L18.5827 2.93487L18.5062 2.87321C16.5433 1.09133 13.9939 0 11.1925 0C5.01102 0 0 5.24877 0 11.7235C0 18.1982 5.01102 23.447 11.1925 23.447C16.8985 23.447 21.5972 18.9713 22.288 13.1907C22.3463 12.7104 22.3849 12.2204 22.3849 11.7235C22.3849 10.8854 22.2976 10.0693 22.138 9.2811Z"/>
                  <path opacity="0.1" d="M14.7266 5.7549C13.7056 5.06124 12.5005 4.6405 11.193 4.6405C7.58719 4.6405 4.66406 7.70226 4.66406 11.4792C4.66406 11.5204 4.66459 11.5526 4.66527 11.5937C4.72818 7.87375 7.62653 4.88474 11.193 4.88474C12.5005 4.88474 13.7056 5.30548 14.7266 5.99914C14.8828 6.10552 15.0441 6.20539 15.1909 6.32483L18.5833 2.93481L15.1909 6.08059C15.0441 5.96115 14.8828 5.86128 14.7266 5.7549Z" fill="black"/>
                  <path opacity="0.2" d="M11.1925 0.24424C13.9673 0.24424 16.493 1.31732 18.4483 3.06921L18.5827 2.93487L18.4801 2.84126C16.5172 1.05937 13.9939 0 11.1925 0C5.01102 0 0 5.24876 0 11.7235C0 11.7647 0.0054651 11.8045 0.00586355 11.8456C0.0690534 5.42783 5.05035 0.24424 11.1925 0.24424Z" fill="white"/>
                </svg>
                <span class="text-xs ml-3 text-[#250000] font-semibold">Zaloguj się z Google</span>
              </a>
              <a :href="'/wp-login.php?loginSocial=facebook&amp;redirect='+window.location.href"
                 class="no-default-style bg-facebook-blue rounded-lg py-2 flex items-center justify-center w-full" rel="nofollow"
                 aria-label="Zaloguj się " data-plugin="nsl" data-action="connect" data-provider="facebook"
                 data-popupwidth="600" data-popupheight="679">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M11.1497 23.4469L11.1597 23.4469H11.1563L11.1497 23.4469ZM11.2287 23.4469H11.2252L11.2352 23.4469L11.2287 23.4469ZM11.1155 23.4467L11.1263 23.4468H11.1201L11.1155 23.4467ZM11.2648 23.4468H11.2586L11.2694 23.4467L11.2648 23.4468ZM11.0826 23.4464L11.0898 23.4465L11.084 23.4464H11.0826ZM11.3009 23.4464L11.2952 23.4465L11.3024 23.4464H11.3009ZM11.3371 23.446L11.3345 23.4461L11.3443 23.4459L11.3371 23.446ZM11.0407 23.4459L11.0504 23.4461L11.0479 23.446L11.0407 23.4459ZM11.3731 23.4455L11.3672 23.4456L11.3792 23.4454L11.3731 23.4455ZM11.0057 23.4454L11.0177 23.4456L11.0118 23.4455L11.0057 23.4454ZM11.4091 23.4448L11.4012 23.445L11.4123 23.4447L11.4091 23.4448ZM10.9726 23.4447L10.9837 23.445L10.9758 23.4448L10.9726 23.4447ZM10.9317 23.4439L10.9415 23.4441L10.9398 23.4441L10.9317 23.4439ZM11.4452 23.4441L11.4434 23.4441L11.4533 23.4439L11.4452 23.4441ZM10.8957 23.4429L10.9092 23.4433L10.9038 23.4431L10.8957 23.4429ZM11.4812 23.4431L11.4757 23.4433L11.4892 23.4429L11.4812 23.4431ZM11.5171 23.4421L11.5084 23.4424L11.5222 23.442L11.5171 23.4421ZM10.8628 23.442L10.8766 23.4424L10.8678 23.4421L10.8628 23.442ZM10.8313 23.441L10.8411 23.4413L10.8319 23.441L10.8234 23.4407L10.8313 23.441ZM11.5531 23.441L11.5438 23.4413L11.5536 23.441L11.5616 23.4407L11.5531 23.441ZM11.589 23.4398L11.5841 23.4399L11.5992 23.4394L11.589 23.4398ZM10.7858 23.4394L10.8009 23.4399L10.796 23.4398L10.7858 23.4394ZM10.753 23.4381L10.7689 23.4387L10.7601 23.4384L10.753 23.4381ZM11.6249 23.4384L11.6161 23.4387L11.6319 23.4381L11.6249 23.4384ZM10.7209 23.4367L10.7364 23.4374L10.7243 23.4369L10.7209 23.4367ZM11.6607 23.4369L11.6486 23.4374L11.664 23.4367L11.6607 23.4369ZM10.6759 23.4347L10.6925 23.4355L10.6884 23.4353L10.6759 23.4347ZM11.6965 23.4353L11.6925 23.4355L11.7091 23.4347L11.6965 23.4353ZM10.6436 23.4331L10.6608 23.4339L10.6527 23.4336L10.6436 23.4331ZM11.7323 23.4336L11.7242 23.4339L11.7414 23.4331L11.7323 23.4336ZM10.6117 23.4314L10.6291 23.4323L10.6169 23.4317L10.6117 23.4314ZM11.7681 23.4317L11.7559 23.4323L11.7732 23.4314L11.7681 23.4317ZM11.8038 23.4298L11.788 23.4306L11.802 23.4299L11.8185 23.4289L11.8038 23.4298ZM10.5829 23.4299L10.597 23.4306L10.5811 23.4298L10.5664 23.4289L10.5829 23.4299ZM11.8395 23.4277L11.8325 23.4281L11.8502 23.427L11.8395 23.4277ZM10.5347 23.427L10.5524 23.4281L10.5454 23.4277L10.5347 23.427ZM10.5031 23.4251L10.5208 23.4262L10.5098 23.4255L10.5031 23.4251ZM11.8752 23.4255L11.8641 23.4262L11.8818 23.4251L11.8752 23.4255ZM10.473 23.4231L10.489 23.4241L10.4741 23.4232L10.4591 23.4222L10.473 23.4231ZM11.9108 23.4232L11.896 23.4241L11.9119 23.4231L11.9258 23.4222L11.9108 23.4232ZM11.9464 23.4208L11.9411 23.4211L11.958 23.4199L11.9464 23.4208ZM10.4269 23.4199L10.4438 23.4211L10.4385 23.4208L10.4269 23.4199ZM10.3954 23.4176L10.412 23.4189L10.4029 23.4182L10.3954 23.4176ZM11.982 23.4182L11.9729 23.4189L11.9895 23.4176L11.982 23.4182ZM10.364 23.4153L10.3792 23.4165L10.3674 23.4156L10.364 23.4153ZM12.0176 23.4156L12.0057 23.4165L12.021 23.4153L12.0176 23.4156ZM10.3217 23.412L10.3351 23.413L10.3318 23.4128L10.3217 23.412ZM12.0531 23.4128L12.0499 23.413L12.0633 23.412L12.0531 23.4128ZM12.0886 23.4099L12.0822 23.4104L12.0958 23.4093L12.0886 23.4099ZM10.2892 23.4093L10.3028 23.4104L10.2964 23.4099L10.2892 23.4093ZM10.2575 23.4066L10.269 23.4076L10.2609 23.4069L10.2575 23.4066ZM12.1241 23.4069L12.1159 23.4076L12.1275 23.4066L12.1241 23.4069ZM10.2226 23.4035L10.226 23.4038L10.2255 23.4038L10.2226 23.4035ZM12.1595 23.4038L12.1589 23.4038L12.1624 23.4035L12.1595 23.4038ZM12.1949 23.4005L12.1917 23.4008L12.1997 23.4001L12.1949 23.4005ZM10.1853 23.4001L10.1932 23.4008L10.19 23.4005L10.1853 23.4001ZM10.1525 23.3969L10.1584 23.3975L10.1547 23.3972L10.1525 23.3969ZM12.2302 23.3972L12.2265 23.3975L12.2324 23.3969L12.2302 23.3972ZM9.44365 23.3044C4.09579 22.424 0 17.5708 0 11.7235C0 5.25313 5.01519 0 11.1925 0C17.3697 0 22.3849 5.25313 22.3849 11.7235C22.3849 17.5708 18.2892 22.424 12.9413 23.3044V15.1123H15.5492L16.0455 11.7235H12.9413V9.52438C12.9413 8.59726 13.3749 7.69355 14.7653 7.69355H16.1766V4.80847C16.1766 4.80847 14.8958 4.57949 13.6712 4.57949C11.1146 4.57949 9.44365 6.20246 9.44365 9.14067V11.7235H6.60181V15.1123H9.44365V23.3044Z" fill="white"/>
                </svg>
                <span class="text-xs ml-3 text-[#F9F9F9] font-semibold">Zaloguj się z Facebook</span>
              </a>
              <div class="w-full text-[10px] text-center flex items-center gap-x-1">
                <span class="inline-block bg-white h-px grow"></span>
                <span class="grow-0">LUB</span>
                <span class="inline-block bg-white h-px grow"></span>
              </div>
            </template>
            <Transition mode="out-in">
              <div v-if="currentCard === 'login'" class="flex flex-col gap-y-3.5">
                <div>
                  <h5 class="text-sm font-semibold mb-1 transition-colors"
                      :class="{'text-zt-red placeholder:text-zt-red': loginEmailError}">Adres e-mail</h5>
                  <input v-model="login" @keydown.enter="doLogin()"
                         @change="loginEmailError = false; checkIfUserHas2faEnabled();"
                         class="min-h-[45px]" placeholder="Wprowadź adres e-mail" type="email" name="email">
                </div>
                <Transition>
                  <p v-if="loginEmailError && loginEmailInfo !== ''" class="ml-1 -mt-2 text-xs text-zt-red">{{ loginEmailInfo }}</p>
                </Transition>
                <div>
                  <div class="flex justify-between items-center">
                    <h5 class="text-sm font-semibold mb-1 transition-colors"
                        :class="{'text-zt-red placeholder:text-zt-red': loginPasswordError}">Hasło</h5>
                    <input class="cursor-pointer border-0 rounded-md bg-neutral-100"
                          id="remember-user-checkbox" type="checkbox" checked hidden>
                    <a href="/przypomnij-haslo/" class="no-default-style text-xs text-zt-more zt-hover">Zapomniałeś hasła?</a>
                  </div>
                  <div class="relative">
                    <input v-model="password" @keydown.enter="doLogin()" @change="loginPasswordError = false"
                           class="min-h-[45px]" placeholder="Wprowadź hasło" :type="showPassword ? 'text' : 'password'"
                           name="password">
                    <button class="absolute top-1/2 right-[10px] -translate-y-1/2" tabindex="-1"
                            @mousedown="showPassword = true" @mouseup="showPassword = false"
                            @touchstart="showPassword = true" @touchend="showPassword = false">
                      <svg width="20" height="20" viewBox="0 0 24 24" class="fill-gray-600"
                           :class="{ 'hidden': showPassword }">
                        <path d="M12 9q1.219 0 2.109 0.891t0.891 2.109-0.891 2.109-2.109 0.891-2.109-0.891-0.891-2.109 0.891-2.109 2.109-0.891zM12 17.016q2.063 0 3.539-1.477t1.477-3.539-1.477-3.539-3.539-1.477-3.539 1.477-1.477 3.539 1.477 3.539 3.539 1.477zM12 4.5q3.703 0 6.703 2.063t4.313 5.438q-1.313 3.375-4.313 5.438t-6.703 2.063-6.703-2.063-4.313-5.438q1.313-3.375 4.313-5.438t6.703-2.063z"></path>
                      </svg>
                      <svg width="20" height="20" viewBox="0 0 24 24" class="fill-gray-600"
                           :class="{ 'hidden': !showPassword }">
                        <path d="M11.859 9h0.141q1.219 0 2.109 0.891t0.891 2.109v0.188zM7.547 9.797q-0.563 1.125-0.563 2.203 0 2.063 1.477 3.539t3.539 1.477q1.078 0 2.203-0.563l-1.547-1.547q-0.375 0.094-0.656 0.094-1.219 0-2.109-0.891t-0.891-2.109q0-0.281 0.094-0.656zM2.016 4.266l1.266-1.266 17.719 17.719-1.266 1.266q-0.234-0.234-1.477-1.453t-1.898-1.875q-2.016 0.844-4.359 0.844-3.703 0-6.703-2.063t-4.313-5.438q0.516-1.219 1.617-2.695t2.133-2.273q-0.563-0.563-1.57-1.594t-1.148-1.172zM12 6.984q-0.938 0-1.828 0.375l-2.156-2.156q1.828-0.703 3.984-0.703 3.703 0 6.68 2.063t4.289 5.438q-1.125 2.766-3.422 4.734l-2.906-2.906q0.375-0.891 0.375-1.828 0-2.063-1.477-3.539t-3.539-1.477z"></path>
                      </svg>
                    </button>
                  </div>
                  <Transition>
                    <p v-if="loginPasswordError && loginPasswordInfo !== ''" class="ml-1 mt-1 text-xs text-zt-red">{{ loginPasswordInfo }}</p>
                  </Transition>
                </div>
                <div v-if="userHas2faEnabled">
                  <h5 class="text-sm font-semibold mb-1 transition-colors"
                      :class="{'text-zt-red placeholder:text-zt-red': tokenError}">Token</h5>
                  <input v-model="wfToken" @keydown.enter="doLogin()" @change="tokenError = false"
                         class="min-h-[45px]" placeholder="Wprowadź token z aplikacji" type="text" name="token">
                </div>
                <div @click="doLogin()"
                     class="w-full bg-zt-red py-3 rounded-lg text-sm font-semibold zt-hover mt-4 mb-3 transition-colors
                            text-center cursor-pointer"
                     :class="{ '!opacity-40': userHas2faEnabled === null }">
                  <span v-if="!showSpinner">ZALOGUJ SIĘ</span>
                  <div v-if="showSpinner" class="spinner" role="status">
                    <span class="invisible">Oczekiwanie...</span>
                  </div>
                </div>
                <div class="flex gap-1 justify-center items-center text-xs">
                  <span class="text-zt-more ">Nie posiadasz konta?</span>
                  <span @click="currentCard = 'register'" class="font-semibold underline cursor-pointer zt-hover">Zarejestruj się</span>
                </div>
                <Transition>
                  <p v-if="loginInfo !== ''" class="text-center text-xs text-zt-red">{{ loginInfo }}</p>
                </Transition>
              </div>
              <div v-else-if="currentCard === 'register'" class="flex flex-col gap-y-3.5">
                <div>
                  <h5 @keydown.enter="doRegister()" class="text-sm font-semibold mb-1 transition-colors"
                      :class="{'text-zt-red placeholder:text-zt-red': registerFirstnameError}">Imię</h5>
                  <input v-model="firstName" @change="registerFirstnameError=false"
                         class="min-h-[45px]" placeholder="Wprowadź imię" type="text" name="firstname">
                </div>
                <Transition>
                  <p v-if="registerFirstnameError && registerFirstnameInfo !== ''" class="ml-1 -mt-2 text-xs text-zt-red">{{ registerFirstnameInfo }}</p>
                </Transition>
                <div>
                  <h5 @keydown.enter="doRegister()" class="text-sm font-semibold mb-1 transition-colors"
                      :class="{'text-zt-red placeholder:text-zt-red': registerLastnameError}">Nazwisko</h5>
                  <input v-model="lastName" @change="registerLastnameError=false"
                         class="min-h-[45px]" placeholder="Wprowadź nazwisko" type="text" name="lastname">
                </div>
                <Transition>
                  <p v-if="registerLastnameError && registerLastnameInfo !== ''" class="ml-1 -mt-2 text-xs text-zt-red">{{ registerLastnameInfo }}</p>
                </Transition>
                <div>
                  <h5 @keydown.enter="doRegister()" class="text-sm font-semibold mb-1 transition-colors"
                      :class="{'text-zt-red placeholder:text-zt-red': registerEmailError}">Adres e-mail</h5>
                  <input v-model="emailAddress" @change="registerEmailError=false"
                         class="min-h-[45px]" placeholder="Wprowadź adres e-mail" type="email" name="email">
                </div>
                <Transition>
                  <p v-if="registerEmailError && registerEmailInfo !== ''" class="ml-1 -mt-2 text-xs text-zt-red">{{ registerEmailInfo }}</p>
                </Transition>
                <div class="flex items-center">
                  <input class="mr-2 form-check-input appearance-none h-6 w-6 border border-gray-400 rounded-md
                                bg-zt-dark transition duration-200 cursor-pointer shrink-0
                                checked:bg-zt-red checked:border-zt-red focus:outline-none"
                         type="checkbox" id="accept-privacy-policy"
                         v-model="privacyPolicy">
                  <label for="accept-privacy-policy">
                    <span class="block text-xs xl:inline xl:mr-2">
                      Zapoznałem się z <a class="!text-xs" href="/polityka-prywatnosci/">polityką prywatności</a> i akceptuję jej postanowienia
                    </span>
                  </label>
                </div>
                <Transition>
                  <p v-if="registerPolicyError && registerPolicyInfo !== ''" class="ml-1 -mt-2 text-xs text-zt-red">{{ registerPolicyInfo }}</p>
                </Transition>
                <div @click="doRegister()"
                     class="w-full bg-zt-red py-3 rounded-lg text-sm font-semibold zt-hover mt-1 mb-3 text-center cursor-pointer">
                  <span v-if="!showSpinner">ZAREJESTRUJ SIĘ</span>
                  <div v-if="showSpinner"
                       class="spinner" role="status">
                    <span class="invisible">Oczekiwanie...</span>
                  </div>
                </div>
                <div class="text-center text-xs -mx-6">
                  Na maila otrzymasz link do wygenerowania hasła
                </div>
                <Transition>
                  <p v-if="registerInfo !== ''" class="text-center text-xs text-zt-red -mx-6">{{ registerInfo }}</p>
                </Transition>
              </div>
              <div v-else-if="currentCard === 'success_register'">
                <div class="text-[#00B112] text-[16px] font-semibold text-center">Dziękujemy za rejestrację!</div>
                <div class="text-[16px] my-4">Dalsze instrukcje otrzymasz na maila, sprawdź skrzynkę spam</div>
                <button class="w-full bg-zt-red py-3 rounded-lg text-xs font-medium transition-shadow
                      duration-500 shadow-[0_2px_15px_rgba(196,12,12,0.4)] hover:shadow-[0_0_25px_rgba(196,12,12,0.8)]"
                        @click="closeModal">
                  Zamknij
                </button>
              </div>
            </Transition>
          </div>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
import utils_mixin from '../../mixins/utils_mixin';

export default {
  name: 'LoginModal',
  mixins: [utils_mixin],
  inject: ['WP'],
  data() {
    this.loginErrorMessages = {
      'invalid_username': 'Podano nieprawidłowy adres e-mail.',
      'invalid_email': 'Podano nieprawidłowy adres e-mail.',
      'authentication_failed': 'Podano nieprawidłowy adres e-mail lub hasło.',
      'incorrect_password': 'Podano nieprawidłowy adres e-mail lub hasło.',
      'empty_username': 'Nie podano adresu e-mail.',
      'empty_password': 'Nie podano hasła.',
      'wfls_twofactor_failed': 'Token nieprawidłowy lub wygasła jego ważność.',
      'wfls_twofactor_required': 'Nie podano tokenu uwierzytelniania dwuskładnikowego.',
    };
    this.registerErrorMessages = {
      'empty_username': 'Nie podano nazwy użytkownika.',
      'invalid_username': 'Podana nazwa użytkownika zawiera niedozwolone znaki.',
      'username_exists': 'Istnieje już użytkownik o takiej nazwie.',
      'empty_email': 'Nie podano adresu e-mail.',
      'invalid_email': 'Podano nieprawidłowy adres e-mail.',
      'email_exists': 'Ten adres e-mail jest już używany przez innego użytkownika.',
      'registerfail': 'Wystąpił nieoczekiwany błąd. Prosimy o kontakt z administracją.',
      'empty_firstname': 'Nie podano imienia.',
      'empty_lastname': 'Nie podano nazwiska.',
      'too_long_firstname': 'Imię może się składać z maksymalnie 15 znaków.',
      'too_long_lastname': 'Nazwisko może się składać z maksymalnie 20 znaków.',
    };
    return {
      isLoginModalOpen: false,
      currentCard: 'login',
      login: '',
      password: '',
      loginInfo: '',
      loginEmailInfo: '',
      loginPasswordInfo: '',
      registerInfo: '',
      registerFirstnameInfo: '',
      registerLastnameInfo: '',
      registerEmailInfo: '',
      registerPolicyInfo: '',
      emailAddress: '',
      firstName: '',
      lastName: '',
      showSpinner: false,
      showPassword: false,
      loginEmailError: false,
      loginPasswordError: false,
      tokenError: false,
      registerFirstnameError: false,
      registerLastnameError: false,
      registerEmailError: false,
      registerPolicyError: false,
      outsideClickOptions: {
        handler: (e) => {
          this.closeModal();
        },
        events: ['dblclick', 'mousedown']
      },
      privacyPolicy: false,
      wfToken: '',
      userHas2faEnabled: null,
    }
  },
  mounted() {
    if (window.location.hash === '#login' || window.location.hash === '#register') {
      if (window.location.hash === '#register') {
        this.currentCard = 'register';
      }
      this.openModal();
      history.replaceState(null, null, ' ');
    }
  },
  methods: {
    openModal() {
      this.isLoginModalOpen = true;
      this.blockScrolling();
    },
    closeModal() {
      this.isLoginModalOpen = false;
      this.unblockScrolling();
    },
    doLogin() {
      if (this.showSpinner || this.userHas2faEnabled === null) {
        return;
      }
      this.loginInfo = '';
      if (this.login === '' || this.password === '') {
        this.loginEmailError = this.login === '';
        this.loginPasswordError = this.password === '';
        const errorMessage = 'Nie podano adresu e-mail lub hasła.';
        if (this.loginEmailError) {
          this.loginEmailInfo = errorMessage;
        } else if (this.loginPasswordError) {
          this.loginPasswordInfo = errorMessage;
        } else {
          this.loginInfo = errorMessage;
        }
        return;
      }
      this.showSpinner = true;
      axios
        .post(this.WP.slowAjaxUrl, {
          endpoint: 'api_login_with_email_and_password',
          log: this.login,
          pwd: this.password,
          'wfls-token': this.wfToken,
          rememberme: true
        }).then(response => {
          if (response.data.success) {
            window.location.reload();
          } else if (response.data.data.length && Object.hasOwn(this.loginErrorMessages, response.data.data[0].code)) {
            const errorCode = response.data.data[0].code;
            const errorMessage = this.loginErrorMessages[errorCode];
            this.loginEmailError = ['invalid_username','invalid_email','authentication_failed','empty_username'].includes(errorCode);
            this.loginPasswordError = ['incorrect_password','authentication_failed','empty_password'].includes(errorCode);
            if (this.loginEmailError) {
              this.loginEmailInfo = errorMessage;
            } else if (this.loginPasswordError) {
              this.loginPasswordInfo = errorMessage;
            } else {
              this.loginInfo = errorMessage;
            }
          } else {
            this.loginInfo = 'Nieznany błąd.';
            this.loginEmailError = this.loginPasswordError = true;
          }
          this.showSpinner = false;
        });
    },
    doRegister() {
      this.registerInfo = '';
      if (this.firstName === '' || this.lastName === '' || this.emailAddress === '' || !this.privacyPolicy) {
        this.registerFirstnameError = this.firstName === '';
        this.registerLastnameError = this.lastName === '';
        this.registerEmailError = this.emailAddress === '';
        this.registerPolicyError = !this.privacyPolicy;
        const errorMessage = 'Należy podać imię, nazwisko i adres e-mail oraz akceptować postanowienia polityki prywatności.';
        if (this.registerFirstnameError) {
          this.registerFirstnameInfo = errorMessage;
        } else if (this.registerLastnameError) {
          this.registerLastnameInfo = errorMessage;
        } else if (this.registerEmailError) {
          this.registerEmailInfo = errorMessage;
        } else if (this.registerPolicyError) {
          this.registerPolicyInfo = errorMessage;
        } else {
          this.registerInfo = errorMessage;
        }
        return;
      }
      this.showSpinner = true;
      axios
        .post(this.WP.slowAjaxUrl, {
          endpoint: 'api_register',
          user_name: this.firstName,
          user_lastname: this.lastName,
          user_email: this.emailAddress
        }).then(response => {
          if (response.data.success) {
            this.currentCard = 'success_register';
            if (this.privacyPolicy) {
              let cookieAllowButton = document.getElementById('cookie-allow-button');
              if (cookieAllowButton) {
                document.cookie = "cookiesAllowed=true; expires=Fri, 31 Dec 9999 23:59:59 GMT;";
                cookieAllowButton.parentElement.classList.add('hidden');
              }
            }
          } else if (response.data.data.length && Object.hasOwn(this.registerErrorMessages, response.data.data[0].code)) {
            const errorCode = response.data.data[0].code;
            const errorMessage = this.registerErrorMessages[errorCode];
            this.registerFirstnameError = ['empty_firstname','too_long_firstname', 'registerfail'].includes(errorCode);
            this.registerLastnameError = ['empty_lastname','too_long_lastname', 'registerfail'].includes(errorCode);
            this.registerEmailError = ['empty_email','invalid_email','email_exists', 'registerfail'].includes(errorCode);
            if (this.registerFirstnameError) {
              this.registerFirstnameInfo = errorMessage;
            } else if (this.registerLastnameError) {
              this.registerLastnameInfo = errorMessage;
            } else if (this.registerEmailError) {
              this.registerEmailInfo = errorMessage;
            } else {
              this.registerInfo = errorMessage;
            }
          } else {
            this.registerInfo = 'Nieznany błąd.';
            this.registerFirstnameError = this.registerLastnameError = this.registerEmailError = true;
          }
          this.showSpinner = false;
        });
    },
    checkIfUserHas2faEnabled() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_has_user_2fa_enabled',
          user_email: this.login
        }).then(response => {
        if (response.data.success) {
          this.userHas2faEnabled = response.data.data;
        } else {
          this.userHas2faEnabled = false;
        }
      });
    }
  }
}
</script>

<style scoped>
  .v-enter-active, .v-leave-active {
    transition: opacity 0.15s ease;
  }
  .v-enter-from, .v-leave-to {
    opacity: 0;
  }
  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-thumb {
    @apply bg-black/20 rounded-xl bg-clip-content border-transparent border-[1px] border-solid;
  }
</style>